import { createElement } from "react";
import type { SectionDef } from "../inspector/schema";
import {
  LoadingScreenControl,
  FullScreenControl,
  FrameFadeControl,
  ModelStageControl,
  RhinoLoaderControl,
  MaterialExtensionTogglesControl,
  ExtrasControl,
} from "./custom/PluginControls";
import {
  SnowControl,
  WaveGroundControl,
  WatchHandsControl,
  Css3dControl,
  RainbowDiamondControl,
} from "./custom/NichePluginControls";

/**
 * Plugins tab — the iJewel `utility_plugins` group, in the schema's exact order:
 * Loading Screen · Full Screen · Frame Fade · Rhino 3dm loader · Model Stage ·
 * Watch Hands Time · CSS3D Renderer · Material extension toggles · Snow Fall ·
 * Wave Ground · Rainbow Diamond Coloring · Extras. (Physics + Scrollable Camera
 * live in the Animations tab and xAtlas in Picking, matching iJewel's grouping.)
 */
export const pluginsSections: SectionDef[] = [
  {
    id: "loadingScreen",
    title: "Loading Screen",
    rows: [{ id: "loader", kind: "custom", label: "", component: () => createElement(LoadingScreenControl) }],
  },
  {
    id: "fullScreen",
    title: "Full Screen",
    defaultCollapsed: true,
    rows: [{ id: "fs", kind: "custom", label: "", component: () => createElement(FullScreenControl) }],
  },
  {
    id: "frameFade",
    title: "Frame Fade",
    defaultCollapsed: true,
    rows: [{ id: "ff", kind: "custom", label: "", component: () => createElement(FrameFadeControl) }],
  },
  {
    id: "rhinoLoader",
    title: "Rhino 3dm loader",
    defaultCollapsed: true,
    rows: [{ id: "rhino", kind: "custom", label: "", component: () => createElement(RhinoLoaderControl) }],
  },
  {
    id: "modelStage",
    title: "Model Stage",
    defaultCollapsed: true,
    rows: [{ id: "stage", kind: "custom", label: "", component: () => createElement(ModelStageControl) }],
  },
  {
    id: "watchHands",
    title: "Watch Hands Time",
    defaultCollapsed: true,
    rows: [{ id: "watch", kind: "custom", label: "", component: () => createElement(WatchHandsControl) }],
  },
  {
    id: "css3d",
    title: "CSS3D Renderer",
    defaultCollapsed: true,
    rows: [{ id: "css3d", kind: "custom", label: "", component: () => createElement(Css3dControl) }],
  },
  {
    id: "materialExtensionToggles",
    title: "Material extension toggles",
    defaultCollapsed: true,
    inert: {
      reason:
        "No RPC. Six read-only \u201cAlways on\u201d rows kept so the section count matches the reference; every extension ships enabled. The real editor is Picking > Material Extensions.",
    },
    rows: [{ id: "extToggles", kind: "custom", label: "", component: () => createElement(MaterialExtensionTogglesControl) }],
  },
  {
    id: "snowFall",
    title: "Snow Fall Particles",
    defaultCollapsed: true,
    rows: [{ id: "snow", kind: "custom", label: "", component: () => createElement(SnowControl) }],
  },
  {
    id: "waveGround",
    title: "Wave Ground",
    defaultCollapsed: true,
    rows: [{ id: "wave", kind: "custom", label: "", component: () => createElement(WaveGroundControl) }],
  },
  {
    id: "rainbowDiamond",
    title: "Rainbow Diamond Coloring",
    defaultCollapsed: true,
    rows: [{ id: "rainbow", kind: "custom", label: "", component: () => createElement(RainbowDiamondControl) }],
  },
  {
    id: "extras",
    title: "Extras (advanced/debug)",
    defaultCollapsed: true,
    rows: [{ id: "extras", kind: "custom", label: "", component: () => createElement(ExtrasControl) }],
  },
];
